exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".events-list {\n  background: #fff;\n  padding-bottom: 4.5rem; }\n  .events-list .events-btn-container {\n    width: 100%;\n    padding: 2.5rem 0; }\n    .events-list .events-btn-container .button {\n      min-width: 24rem; }\n  .events-list .fetch-failure-message, .events-list .error {\n    height: 50vh;\n    font-weight: 600;\n    font-size: 1.2em;\n    padding: 3.5rem 0; }\n  @media screen and (max-width: 576px) {\n    .events-list {\n      padding-bottom: 2.5rem; } }\n  @media screen and (max-width: 480px) {\n    .events-list .events-btn-container .button {\n      width: 100%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/pages/EventsPage/EventsList/EventsList.scss
// module id = 1528
// module chunks = 0